<template>
    <CContainer>
        <CDataTable 
            hover
            responsive
            :fields="gridFields"
            :items="records">
            <template #producto="{item}">
                <td>
                    <div>
                        <span>{{ item.Descripcion }}</span>
                    </div>
                    <div>
                        <h5>{{ item.Codigo }}</h5>
                    </div>
                </td>
            </template>
            <template #cantidades="{item}">
                <td class="td-right">
                    <div>
                        <span>{{ item.Salidas }}</span>
                    </div>
                    <div>
                        <span>${{ formatter.format(item.Valor_Producto, 2) }}</span>
                    </div>
                </td>
            </template>
            <template #totales="{item}">
                <td class="td-right">
                    <div>
                        <h5>${{ formatter.format(item.Valor_Salidas, 2) }}</h5>
                    </div>
                </td>
            </template>
        </CDataTable>

        <CElementCover v-show="loading" />
    </CContainer>
</template>
<style>
    .td-right {
        text-align: right;
    }
</style>
<script>
    import moment from "moment"
    import { formatter } from "../../general"
    import { dataDocumentoMovimientosKardex } from "../../apiDataGrids"

    const gridFields = [
        {
            key: "producto",
            label: "Producto",
            _style: "text-align:center"
        },
        {
            key: "cantidades",
            label: "Cantidades",
            _style: "text-align:center"
        },
        {
            key: "totales",
            label: "Totales",
            _style: "text-align:center"
        }
    ]
    export default {
        name: "DocumentKardex",
        data () {
            return {
                formatter,
                loading: false,
                gridFields,
                records: []
            }
        },
        props: {
            idDocument: String
        },
        methods: {
            moment,
            async getData() {
                if (this.idDocument) {
                    this.loading = true

                    try {
                        const { response } = await dataDocumentoMovimientosKardex(this, this.idDocument)

                        this.records = response

                        console.log(this.records);
                    } catch(error) {
                        this.$store.commit("setAlert", {
                            color: "danger",
                            message: "NO se pudo cargar los datos los movimientos del documento.",
                            show: 5
                        })
                    } finally {
                        this.loading = false
                    }
                }
            }
        },
        mounted() {
            this.getData()
        }
    }
</script>